// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_QJp","cls2":"ImpactStatTile-cls2_hJs ImpactStatTile-cls1_QJp"};